// Keep the multipart claim request under the API proxy body limit (128 MiB).
// File sizes exclude multipart boundaries and serialized claim data.
export const MAX_CLAIM_DOCUMENTS_SIZE_MB = 100;
export const MAX_CLAIM_DOCUMENTS_SIZE_BYTES = MAX_CLAIM_DOCUMENTS_SIZE_MB * 1024 * 1024;

export const CLAIM_DOCUMENTS_TOO_LARGE_MESSAGE = `The combined size of all documents must be ${MAX_CLAIM_DOCUMENTS_SIZE_MB} MB or less. Please compress or remove documents and try again.`;

export const CLAIM_NETWORK_ERROR_MESSAGE =
  'We could not submit your claim because the connection was interrupted. Please keep all documents under 100 MB total and try again.';

const asFileList = (value) => {
  if (!value) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
};

export const getClaimDocumentsSize = ({ leaseFile, ledgerFile, otherFiles } = {}) =>
  [...asFileList(leaseFile), ...asFileList(ledgerFile), ...asFileList(otherFiles)].reduce(
    (total, file) => total + (Number(file && file.size) || 0),
    0,
  );

export const exceedsClaimDocumentsSizeLimit = (documents) =>
  getClaimDocumentsSize(documents) > MAX_CLAIM_DOCUMENTS_SIZE_BYTES;

export const formatClaimDocumentsSizeMb = (bytes) => (bytes / 1024 / 1024).toFixed(1);

export const isClaimNetworkError = (error) =>
  !error?.response && (error?.code === 'ERR_NETWORK' || error?.message === 'Network Error');
